export const PERMISSIONS_SCHEMA = [
  {
    title: 'Audiences',
    entities: [
      'Audience Insights',
      'Audience Creator',
      'Branded Audiences',
      'AB Custom Audiences',
      'White Label Audiences',
      'Pixel Audiences',
    ],
  },
  {
    title: 'Data Explorer',
    entities: ['Cohorts', 'DaaS Clients', 'Events', 'Users'],
  },
  {
    title: 'Data Feeds',
    entities: ['Event Feeds', 'User Feeds'],
  },
  {
    title: 'Integrations',
    entities: [
      'AppNexus Audiences',
      'TTD Audiences',
      'TTD Health Audiences',
      'Partner Branded Audiences',
    ],
  },
  {
    title: 'Operations',
    entities: [
      'Companies',
      'Content Rule Logs',
      'Content Rules',
      'Data Sources',
      'Destinations',
      'Links',
      'Log Files',
      'Mapping IDs',
      'People',
      'Regions',
    ],
  },
  {
    title: 'User Profiles',
    entities: ['User Attribute Sync'],
  },
]

export const OPTION_NAMES = {
  ACCOUNT_SETTINGS: 'Account',
  MANAGE_COLLABORATORS: 'Manage collaborators',
  EDIT_COLLABORATOR: 'Edit Collaborator',
  INVITE_NEW_MEMBER: 'Invite New Members',
  MANAGE_PERMISSION_SETS: 'Manage permission sets',
  INVITATIONS: 'Invitations',
}

export const NEW_USER_INITIAL = {
  emails: [],
  org: '',
  permissions: {},
}
